import React from 'react'
import i18next from 'i18next'
import { ReservationStatusLabels } from 'types/common'
import type { ReservationFormProps } from 'types/applicant'
import type { ReservationDetailProps, ReservationListItem } from 'types/med'

export const reservationStatusLabelText: (
  status: ReservationFormProps | ReservationDetailProps | ReservationListItem
) => React.ReactNode = (reservation) => {
  if (!reservation?.call_method && reservation.status?.startsWith('finish')) {
    return i18next.t('実施完了')
  }
  return reservation?.status && ReservationStatusLabels[reservation.status]
    ? i18next.t(ReservationStatusLabels[reservation.status])
    : null
}
